import { useEffect, useState } from 'react'
import { api, db, engine } from '@/runtime'
import { accessOf, rememberAccess } from '@/state/access'
import { META } from '@/db/schema'
import { AuthError } from '@/db/api'
import { Button } from './ui'

/** The only loading state in the app: the very first pull. */
export const BootstrapScreen = ({ onDone, onBadToken }: { onDone: () => void; onBadToken: () => void }) => {
  const [error, setError] = useState<string | null>(null)
  const [attempt, setAttempt] = useState(0)
  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        const name = await db.getMeta<string>(META.deviceName)
        // who the server says this token is: the owner, or a workspace member
        const cfg = await api.config()
        const access = accessOf(cfg)
        const { member } = access
        const before = await db.getMeta<boolean>(META.member)
        if (before !== undefined && before !== !!member) {
          // a different kind of sign-in on this device: the old one's unsent writes are not this one's to send
          await db.ops.clear()
        }
        await db.setMeta(META.member, member)
        await rememberAccess(db, access)
        await engine.bootstrap(name)
        if (!cancelled) onDone()
      } catch (e) {
        if (cancelled) return
        if (e instanceof AuthError) {
          await db.setMeta(META.token, undefined)
          onBadToken()
          return
        }
        setError((e as Error).message)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [attempt, onDone, onBadToken])
  return (
    <main className="min-h-dvh flex items-center justify-center p-6 text-center">
      <div>
        {error ? (
          <>
            <p className="text-fg-2 mb-1">Couldn't reach the server.</p>
            <p className="text-xs text-faint mb-4">{error}</p>
            <Button variant="primary" onClick={() => setAttempt((a) => a + 1)}>
              Try again
            </Button>
          </>
        ) : (
          <p className="text-muted animate-pulse">Loading your things…</p>
        )}
      </div>
    </main>
  )
}
